import { render, staticRenderFns } from "./UcContractSelector.yaml?vue&type=template&id=1fe245bc&component"
import script from "./UcContractSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports